import { createAction } from '@reduxjs/toolkit';

import { useAnimatedModal } from '@perpay-web/components/base/Modal/useAnimatedModal';
import { useModal } from '@perpay-web/components/base/Modal/useModal';
import { useActionObservableCallback } from '@perpay-web/hooks/useActionObservableCallback';
import { useSteps } from '@perpay-web/hooks/useSteps';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

export const ADD_TO_WALLET_STEP = 'add-to-wallet';
export const SUCCESS_STEP = 'success';
const VIRTUAL_PROVISIONING_MODAL_STEPS = [ADD_TO_WALLET_STEP, SUCCESS_STEP];

export const virtualProvisioningSetIsModalOpen = createAction(
    'VIRTUAL_PROVISIONING_MODAL::SET_IS_MODAL_OPEN',
);

export const virtualProvisioningModalSetStep = createAction(
    'VIRTUAL_PROVISIONING_MODAL::SET_STEP',
);

const useVirtualProvisioningModal = () => {
    const steps = useSteps(
        VIRTUAL_PROVISIONING_MODAL_STEPS,
        ADD_TO_WALLET_STEP,
    );

    const { isModalOpen, setIsModalOpen } = useModal();

    const {
        isAnimatedModalOpen,
        setIsAnimatedModalOpen,
        animatedModalClassName,
    } = useAnimatedModal({ isModalOpen, setIsModalOpen });

    return {
        ...steps,
        isAnimatedModalOpen,
        setIsAnimatedModalOpen,
        animatedModalClassName,
    };
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const hook = useVirtualProvisioningModal();

        useActionObservableCallback(
            hookAction$,
            virtualProvisioningSetIsModalOpen().type,
            (value) => {
                hook.setIsAnimatedModalOpen(value);
            },
        );

        useActionObservableCallback(
            hookAction$,
            virtualProvisioningModalSetStep().type,
            (value) => {
                hook.setStep(value);
            },
        );

        return <Context.Provider value={hook}>{children}</Context.Provider>;
    };

    return Provider;
};

export const [VirtualProvisioningProvider, useVirtualProvisioningContext] =
    createContextProvider(providerFactory);
